import { useCallback } from 'react'
import { keyEqualTo } from '@disco/utils/keyboard'

export const useKeyPress = (key: string, onPress?: () => void) => {
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLElement>) => {
      if (keyEqualTo(e, key)) {
        e.preventDefault()
        e.stopPropagation()
        onPress?.()
      }
    },
    [key, onPress],
  )

  return { handleKeyDown }
}
